import { createContext } from 'react';

interface SpreadsheetCellType {
  fieldName: string;
}

export const CellContext = createContext({} as SpreadsheetCellType);
